import Image from "../_app/cuchillo/3D/Image";
import Video from "../_app/cuchillo/3D/Video";
import { GetBy } from "../_app/cuchillo/core/Element";
import Box from "./Box";

export default class BoxInspiration extends Box {
  constructor(__dom) {
    super(__dom);

    const image = GetBy.selector('[data-image]', __dom)[0];
    if (image) {
      const image3D = new Image({
        dom: image,
        size: {
          y: parseInt(image.dataset.height),
          x: parseInt(image.dataset.width)
        }
      });

      this.add(image3D);
      this.items.push(image3D);
    } else {
      const video = GetBy.selector('[data-video]', __dom)[0];
      const video3D = new Video({
        dom: video,
        size: {
          y: parseInt(video.dataset.height),
          x: parseInt(video.dataset.width)
        }
      });

      this.add(video3D);
      this.items.push(video3D);
    }
  }
}
